// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3mtfZ","modal":"Modal_modal__2TxAm","slide-down":"Modal_slide-down__2Cllg"};